import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { TaskAssignment } from '@entities/task-assignment';
import { EntityService } from '@app/shared/services/entity.service';
import { select, Store } from '@ngrx/store';
import { getOrganizationId } from '@app/user-org/state/user-org.selectors';
import { OrgEntityService } from '@app/shared/services/org-entity.service';
import { COLLECTION_NAMES } from '@app/shared/services/collection-names';
import { State } from '@app/app.state';

@Injectable()
export class TaskAssignmentService implements EntityService<TaskAssignment>, OnDestroy {
   readonly COLLECTION_NAME: string = COLLECTION_NAMES.TASK_ASSIGNMENTS;
   entities$: Observable<TaskAssignment[]>;

   private orgId$: Observable<string> = this.store.pipe(select(getOrganizationId));
   private orgEntityService = new OrgEntityService<TaskAssignment>();

   constructor(private store: Store<State>) {
      this.orgEntityService.init(this.orgId$, this.COLLECTION_NAME);
      this.entities$ = this.orgEntityService.entities$;
   }
   ngOnDestroy() {
      this.orgEntityService.destroy();
   }
   save(entity: TaskAssignment): Promise<TaskAssignment> {
      return this.orgEntityService.save(entity);
   }
   batchSave(entities: TaskAssignment[]): Promise<TaskAssignment[]> {
      return this.orgEntityService.batchSave(entities);
   }
   delete(entity: TaskAssignment): Promise<void> {
      return this.orgEntityService.delete(entity);
   }
}
